import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row justify-between items-center gap-2" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider text-sm sm:text-base" data-id="element-13">
              PARENT HEALTH
            </span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
              </svg>
            </div>
            <span className="text-xs sm:text-sm" data-id="element-21">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-22">
        <div className="container mx-auto px-4 py-3" data-id="element-23">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-24">
            PARENT HEALTH | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-25">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-26">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-27" />
          <p className="font-bold text-xs sm:text-sm md:text-base" data-id="element-28">
            UPDATE: Nymera Kids Focus Drops Are Selling Out FAST! Grab Yours NOW
            to get 25% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-29">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-30">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-31">
            <div className="py-6 px-0 md:px-4" data-id="element-32">
              {/* Headline */}
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 leading-tight" data-id="element-33">
                Every 'Fortified' Breakfast Cereal Is Blocking Your Child's
                Brain Development — And Doctors Never Told You Why
              </h1>

              {/* Subheadline */}
              <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-34">
                If your child struggles with focus, mood swings, or speech
                delays despite eating 'healthy' fortified foods, this might
                explain everything.
              </p>

              {/* Author and Date */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 pb-4 mb-6 gap-2" data-id="element-35">
                <div className="flex items-center" data-id="element-36">
                  <p className="text-xs sm:text-sm text-gray-700" data-id="element-37">
                    By Jennifer Martinez, Parent Health Advocate | January 6,
                    2025
                  </p>
                </div>
                <div className="flex items-center text-xs sm:text-sm text-gray-500" data-id="element-38">
                  <EyeIcon size={16} className="mr-1" data-id="element-39" />
                  <span data-id="element-40">127,483</span>
                </div>
              </div>

              {/* Featured Image - IMAGE 1 */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/j2d21JXde3jCAgwLJGY495/ChatGPT_Image_11_Ιαν_2026,_12_26_34_μ.μ..png" alt="Stressed mother with child at breakfast table with fortified cereal, depicting morning struggles and parental concern" className="w-full h-auto" data-id="element-42" />
              </div>

              {/* Opening Section */}
              <div className="mb-10" data-id="element-43">
                <p className="mb-4 text-base leading-relaxed" data-id="element-44">
                  Picture this morning.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-45">
                  You pour your child a bowl of cereal. You check the box.
                  Vitamins added. Minerals added. Folic acid. Iron. All the good
                  stuff.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-46">
                  You're doing everything right.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-47">
                  But what if those "healthy" vitamins are actually making
                  things worse?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-48">
                  Here's something most parents don't know.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-49">
                  Since 1998, the U.S. government has required that all cereals,
                  breads, and snacks be "fortified" with a synthetic vitamin
                  called folic acid. They said it would help kids grow strong
                  and healthy. They said it would prevent birth defects.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-50">
                  And for some kids, it did.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-51">
                  But for nearly half of all children, this synthetic vitamin is
                  creating a traffic jam in the brain.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-52">
                  And every bowl of cereal, every piece of toast, every
                  "healthy" fortified snack is making that traffic jam worse.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-53">
                  It's not your fault.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-54">
                  You've been trying to feed your child nutritious foods. You
                  read labels. You buy organic. You cut out dyes and sugar.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-55">
                  But the vitamins they added to those foods? They're not the
                  right kind for millions of kids.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-56">
                  And if your child is one of them, it might explain everything
                  you've been struggling with.
                </p>
              </div>

              {/* Does This Sound Like Your Child Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-57">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-58">
                  Does This Sound Like Your Child?
                </h2>

                {/* IMAGE 2 */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-59">
                  <img src="https://cdn.magicpatterns.com/uploads/rmh1ugHvGfHJcfpn4zaYdY/ChatGPT_Image_11_Ιαν_2026,_12_26_32_μ.μ..png" alt="Child struggling with homework, looking distracted and unfocused while parent tries to help" className="w-full h-auto" data-id="element-60" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-61">Let me guess.</p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-62">
                  Mornings are a battle. Getting your child dressed, fed, and
                  out the door feels like you're managing a crisis. Every.
                  Single. Day.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-63">
                  Homework takes three hours. And it ends in tears. Your child
                  knows the answers. But they can't focus long enough to finish.
                  You've tried rewards. You've tried consequences. Nothing
                  works.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-64">
                  Your email inbox fills up with messages from teachers. "Can we
                  talk?" "We're seeing some concerns." "Have you considered
                  testing?"
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-65">
                  The mood swings come out of nowhere. One minute they're fine.
                  The next, they're melting down over something small. By 5 PM
                  every day, it's World War III in your house.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-66">
                  Food is another battle. Your child only eats five things.
                  You've tried hiding vegetables. You've tried bribes. Dinner
                  ends in frustration every night.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-67">
                  And maybe your child is behind on speech. Or they have trouble
                  finding words. Or they seem "foggy" and not fully present.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-68">
                  You watch other kids make friends easily. Your child
                  struggles. They want to fit in. But something just feels
                  harder for them.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-69">
                  You've tried everything.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-70">
                  You went gluten-free. No artificial dyes. No sugar before bed.
                  Better sleep routines. More structure. More outdoor time.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-71">
                  Maybe you even bought expensive vitamins from the health food
                  store. Organic multivitamins. Fish oil. Probiotics. Magnesium.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-72">
                  You've spent thousands on therapy. Occupational therapy twice
                  a week. Speech therapy. Behavioral therapy. Someone to help
                  with social skills.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-73">
                  Some things helped a little. But not enough.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-74">
                  You still see your child struggle. And you're exhausted.
                </p>
              </div>

              {/* The Guilt No One Talks About Section */}
              <div className="mb-10" data-id="element-75">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-76">
                  The Guilt No One Talks About
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-77">
                  Here's what no one says out loud.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-78">
                  You wonder if you're doing something wrong.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-79">
                  Your mother-in-law hints that you're too soft. "Kids these
                  days just need more discipline." The teacher suggests
                  medication. Your pediatrician says, "Let's wait and see."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-80">
                  You lie awake at night wondering if your child will be okay.
                  Will they be able to succeed in school? Make friends? Be
                  happy?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-81">
                  You're doing everything you know how to do. And it's still not
                  enough.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-82">
                  But what if it's not your fault?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-83">
                  What if it's not a discipline problem?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-84">
                  What if it's not that your child isn't trying hard enough?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-85">
                  What if there's a missing piece that doctors never checked
                  for?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-86">
                  Because here's the truth that's going to make you angry.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-87">
                  There is a missing piece. And it's been hiding in your kitchen
                  this whole time.
                </p>
              </div>

              {/* The Hidden Problem Section */}
              <div className="mb-10" data-id="element-88">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-89">
                  The Hidden Problem Hiding in Your Kitchen
                </h2>

                {/* IMAGE 3 */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-90">
                  <img src="https://cdn.magicpatterns.com/uploads/sbR2p6FXXPMWhUQVAvmiEm/ChatGPT_Image_11_Ιαν_2026,_12_26_30_μ.μ..png" alt="Various fortified breakfast foods and snacks with visible 'Fortified with Folic Acid' labels on packaging" className="w-full h-auto" data-id="element-91" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-92">
                  In 1998, the U.S. government made a rule.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-93">
                  All grain products had to be "fortified" with a vitamin called
                  folic acid. Every cereal. Every loaf of bread. Every pasta.
                  Every snack made with flour.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-94">
                  The goal was good. They wanted to prevent birth defects. And
                  for many people, it worked.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-95">
                  But here's what they didn't tell you.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-96">
                  They added a synthetic version of folate called "folic acid."
                  It's not the same as the natural folate found in leafy greens
                  and beans. It's a man-made version.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-97">
                  Your child's body is supposed to take that folic acid and
                  convert it into a usable form called 5-MTHF.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-98">
                  5-MTHF is what the brain actually uses. It's the fuel that
                  helps make important brain chemicals like dopamine and
                  serotonin.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-99">
                  Dopamine controls focus and attention. Serotonin controls mood
                  and emotional balance.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-100">
                  Without enough of these chemicals, kids struggle. They can't
                  focus. Their moods swing. Speech and communication get harder.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-101">
                  Here's the problem.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-102">
                  About 40 to 60 percent of children have a gene variant that
                  makes it hard to convert folic acid into 5-MTHF.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-103">
                  It's called the MTHFR gene.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-104">
                  Some parents call it the "mother-effer gene" because of all
                  the headaches it causes.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-105">
                  If your child has this gene, their body can't do the
                  conversion. Or it does it very slowly.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-106">
                  So all those fortified foods? They're creating a traffic jam.
                </p>
              </div>

              {/* Think of It Like This Section */}
              <div className="mb-10" data-id="element-107">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-108">
                  Think of It Like This
                </h2>

                {/* Brain Chemistry Illustration */}
                <div className="mb-6 rounded-lg overflow-hidden bg-gray-50 p-2 sm:p-4" data-id="element-109">
                  <img src="https://cdn.magicpatterns.com/uploads/faWPXVkeGvmnLAHAeNk7Jb/ChatGPT_Image_11_Ιαν_2026,_12_39_18_μ.μ..png" alt="Brain chemistry illustration comparing Folic Acid (blocked pathways with STOP signs) versus 5-MTHF (flowing pathways with clear circulation)" className="w-full h-auto" data-id="element-110" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-111">
                  Imagine your child's brain is waiting for a fuel delivery.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-112">
                  The fuel truck (folic acid) shows up at the gate. But the gate
                  won't open. The truck just sits there. Blocking the road.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-113">
                  More trucks arrive. But none of them can get through. The road
                  is jammed.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-114">
                  Meanwhile, the brain is running on empty. It can't make enough
                  dopamine for focus. It can't make enough serotonin for mood
                  balance. It's struggling to keep up.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-115">The result?</p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-116">
                  Focus problems. Mood swings. Speech delays. Behavioral
                  struggles. Exhaustion.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-117">
                  And every bowl of fortified cereal, every piece of bread,
                  every "healthy" snack with added folic acid is making that
                  traffic jam worse.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-118">
                  You've been trying to feed your child nutritious foods.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-119">
                  You read the labels. You saw "fortified with folic acid" and
                  thought that was a good thing.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-120">
                  But the vitamins they added? They're blocking what your
                  child's brain actually needs.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-121">
                  That's why the diet changes didn't fully work. That's why the
                  regular vitamins didn't help.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-122">
                  It wasn't that those things were bad. It's that they didn't
                  clear the traffic jam.
                </p>
              </div>

              {/* Why Didn't My Doctor Tell Me Section */}
              <div className="mb-10" data-id="element-123">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-124">
                  "Why Didn't My Doctor Tell Me This?"
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-125">
                  This is the question every parent asks.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-126">
                  If this is real, why didn't my pediatrician mention it?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-127">
                  Here's the truth. Most doctors follow CDC guidelines. And the
                  CDC actually discourages routine MTHFR testing. They say it's
                  not necessary.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-128">
                  They still recommend folic acid for everyone. Even though we
                  now know that up to 60 percent of people can't process it
                  well.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-129">
                  Why? Because it's easier to have one recommendation for
                  everyone than to personalize nutrition.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-130">
                  And because admitting there's a problem with fortification
                  would mean admitting they made a mistake.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-131">
                  Functional medicine doctors have known about this for years.
                  They test for MTHFR. They recommend methylated vitamins.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-132">
                  But mainstream pediatrics? They're about 10 years behind.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-133">
                  So thousands of parents are figuring this out on their own.
                  Through Facebook groups. Through online research. Through
                  other parents who've been there.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-134">
                  And once they know, everything changes.
                </p>
              </div>

              {/* What Parents Are Discovering Section */}
              <div className="mb-10" data-id="element-135">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-136">
                  What Parents Are Discovering
                </h2>

                {/* IMAGE 4 */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-137">
                  <img src="https://cdn.magicpatterns.com/uploads/eQu5qVfYtgQ9kqFJ8MAMAe/ChatGPT_Image_11_Ιαν_2026,_12_26_29_μ.μ..png" alt="Diverse group of parents sharing information and support, looking at phone together with hope and interest" className="w-full h-auto" data-id="element-138" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-139">
                  Sarah from Ohio shared her story in a parent support group.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-140">
                  "We eliminated gluten. We tried occupational therapy. We spent
                  thousands on supplements. Nothing worked."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-141">
                  "Then a mom in my Facebook group mentioned methylfolate. I
                  didn't even know what it was. I had to Google it."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-142">
                  "Within a month, his teachers asked what changed. He's
                  focusing better. He's calmer. Homework doesn't end in tears
                  anymore."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-143">
                  "I wish someone had told me about this three years ago."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-144">
                  Jessica from California had a similar experience.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-145">
                  "My daughter is 7. She's always been anxious. She struggled in
                  school. Her pediatrician wanted to put her on medication."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-146">
                  "I said no. I wanted to try other things first. That's when I
                  found out about the MTHFR gene."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-147">
                  "We started giving her liquid drops with methylfolate. Just a
                  few drops in her morning juice."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-148">
                  "Every teacher and therapist has commented on the difference
                  this school year. She's finally thriving."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-149">
                  Michael from Texas noticed changes in his 4-year-old son.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-150">
                  "He wasn't talking much. We were in speech therapy twice a
                  week. Making slow progress."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-151">
                  "Someone in our therapy group mentioned methylfolate for kids
                  with the MTHFR gene."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-152">
                  "I didn't know if it would help. But within a few weeks, he
                  started using more words. He's more present. More engaged."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-153">
                  "When we run out and forget to reorder, we really notice the
                  difference."
                </p>
              </div>

              {/* The Pattern Is Clear Section */}
              <div className="mb-10" data-id="element-154">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-155">
                  The Pattern Is Clear
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-156">
                  Thousands of parents are seeing the same thing.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-157">
                  Better focus. Calmer moods. More words. Better sleep. Less
                  anxiety.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-158">
                  Kids who were struggling are finally making progress.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-159">
                  Teachers are noticing. Therapists are noticing. Even
                  grandparents are asking, "What changed?"
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-160">
                  And these parents finally have an answer that makes sense.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-161">
                  They're not fighting their child's body with medications that
                  have scary side effects.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-162">
                  They're not white-knuckling through endless behavioral
                  strategies.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-163">
                  They're giving their child's brain the fuel it's been missing
                  all along.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-164">
                  The right form of folate. The kind their body can actually
                  use.
                </p>
              </div>

              {/* So What's the Solution Section */}
              <div className="mb-10" data-id="element-165">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-166">
                  So What's the Solution?
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-167">
                  Here's the good news.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-168">
                  Once you understand the problem, the solution is simple.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-169">
                  Instead of giving your child folic acid (the synthetic form
                  they can't convert), you give them the already-converted form.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-170">
                  It's called 5-MTHF. Also known as L-methylfolate.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-171">
                  It's the exact form the brain uses. No conversion needed. No
                  traffic jam. Just pure brain fuel.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-172">
                  Think of it like this.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-173">
                  Your child's body can't turn a key. So instead of giving them
                  more keys that don't work, you just unlock the door for them.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-174">
                  You skip the broken step entirely.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-175">
                  When the brain finally gets 5-MTHF in a form it can use,
                  everything changes.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-176">
                  It can make dopamine for focus and attention.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-177">
                  It can make serotonin for mood balance.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-178">
                  It can support speech and communication.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-179">
                  It can do what it's been trying to do all along.
                </p>
              </div>

              {/* But There's One More Thing Section */}
              <div className="mb-10" data-id="element-180">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-181">
                  But There's One More Thing
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-182">
                  Here's something most people don't know.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-183">
                  5-MTHF can't work alone.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-184">
                  It needs a partner vitamin. A helper. It's called methyl B12.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-185">
                  Together, they're like the spark plugs in an engine. You need
                  both. One without the other doesn't work.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-186">
                  But together? They turn on your child's brain chemistry.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-187">
                  Most supplements get this wrong. They give you one or the
                  other. But not both. Or they give you the wrong forms.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-188">
                  And the delivery method matters too.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-189">
                  Pills have to go through digestion. Kids with gut issues (very
                  common in this group) can't break them down well.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-190">
                  Gummies are full of sugar. And they still have to be digested.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-191">
                  Liquid drops go straight into the bloodstream through the
                  mouth. Fast. Effective. No digestion needed.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-192">
                  You can mix them in juice. In a smoothie. In milk. Your child
                  won't even taste them.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-193">
                  No fights. No gagging. No battles.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-194">
                  Just a few drops each morning. And you're done.
                </p>
              </div>

              {/* Introducing Nymera Section */}
              <div className="mb-10" data-id="element-195">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-196">
                  Introducing Nymera Kids Focus Drops
                </h2>

                {/* IMAGE 5 - Product Hero */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-197">
                  <img src="https://cdn.magicpatterns.com/uploads/xthJku3oB8jV4yfrHzUrKc/ChatGPT_Image_11_Ιαν_2026,_12_26_25_μ.μ..png" alt="Nymera Kids Focus Drops bottle with dropper, showing Bioactive Folate + B12 and Berry Flavor" className="w-full h-auto" data-id="element-198" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-199">
                  This is what thousands of parents have discovered.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-200">
                  Nymera Kids Focus Drops.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-201">
                  It's a simple liquid. Organic berry flavor. Just a few drops
                  each morning in your child's juice or smoothie.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-202">
                  It contains 5-MTHF. The active form of folate that your
                  child's brain can actually use.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-203">
                  Plus methyl B12. The helper vitamin that makes it work.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-204">
                  In the exact ratio that functional medicine doctors recommend.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-205">
                  This is not like the multivitamin you're currently using.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-206">
                  Check your bottle right now. Look at the ingredient list.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-207">
                  Does it say "folic acid"? Or does it say "folate" or "5-MTHF"?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-208">
                  If it says folic acid, your child's body has to convert it
                  first. And if they have the MTHFR gene, they can't.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-209">
                  Even some expensive organic vitamins get this wrong.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-210">
                  Nymera uses the pre-converted form. The form that skips the
                  broken step entirely.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-211">
                  And it's liquid.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-212">
                  No choking on pills. No sugar-loaded gummies. No wrestling
                  your child to take their vitamins.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-213">
                  Just mix a few drops in their morning drink. They won't even
                  notice.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-214">
                  You control exactly how much they get. Start with just a few
                  drops. Increase slowly. Find the perfect amount for your
                  child.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-215">
                  One bottle lasts weeks.
                </p>
              </div>

              {/* FAQ Sections */}
              <div className="mb-10" data-id="element-216">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-217">
                  "How Is This Different from What We're Already Doing?"
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-218">
                  You might be thinking: "We're already giving our child
                  vitamins. How is this different?"
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-219">
                  Great question.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-220">
                  Here's the truth. Most multivitamins use synthetic folic acid.
                  The kind your child's body has to convert.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-221">
                  And if your child has the MTHFR gene (remember, up to 60
                  percent of kids do), they can't do that conversion well.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-222">
                  So it doesn't matter how many vitamins you give them. The
                  traffic jam is still there.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-223">
                  Nymera gives you the already-converted form. 5-MTHF.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-224">
                  It goes straight to work. No conversion needed. Direct brain
                  fuel.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-225">
                  Plus, it has methyl B12. The helper vitamin that most products
                  leave out.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-226">
                  And it's liquid. Which means faster absorption and no fights.
                </p>
              </div>

              <div className="mb-10" data-id="element-227">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-228">
                  "Will My Child Actually Take It?"
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-229">
                  Another common question: "My child is so picky. They won't
                  even take gummies. How will I get them to take this?"
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-230">
                  Here's the thing.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-231">
                  It's liquid. You can hide it.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-232">
                  Mix it in their morning juice. In their smoothie. In chocolate
                  milk. In yogurt.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-233">
                  The berry flavor is mild. Most kids don't even notice it.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-234">
                  And because you control the dose, you can start with just one
                  or two drops. Build up slowly.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-235">
                  No more wrestling matches trying to get them to swallow pills.
                  No more bribing them to chew gummies they hate.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-236">
                  Just a few drops in their drink. Done.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-237">
                  Parents tell us this is one of their favorite things about it.
                  It's actually easy.
                </p>
              </div>

              <div className="mb-10" data-id="element-238">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-239">
                  "How Long Before We See Results?"
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-240">
                  Every child is different.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-241">
                  Some parents notice changes within days. Others in a few
                  weeks.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-242">
                  The brain needs time to rebuild its chemistry. To start making
                  those important brain chemicals again.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-243">
                  Give it at least 30 days.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-244">
                  Watch for small signs first.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-245">
                  Better sleep. A calmer morning. Homework that goes a little
                  smoother.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-246">
                  Teachers might mention that your child is more focused. More
                  engaged.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-247">
                  Your child might start using more words. Or handling changes
                  better.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-248">
                  The improvements build over time.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-249">
                  And if you run out? Many parents say they notice the
                  difference within a few days. The focus slips. The mood swings
                  come back. That's how they know it's working.
                </p>
              </div>

              <div className="mb-10" data-id="element-250">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-251">
                  "Is It Safe?"
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-252">Yes.</p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-253">
                  This is not a drug. It's a vitamin. The exact nutrient your
                  child's body should be making naturally from food.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-254">
                  Thousands of parents use it. Functional medicine doctors
                  recommend it.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-255">
                  It's the most bioavailable form of folate. The form your
                  child's brain was designed to use.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-256">
                  You can adjust the dose to find what works perfectly for your
                  child. Start low. Go slow.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-257">
                  And if your child is one of the rare ones who doesn't tolerate
                  methylated nutrients well, you just stop. No withdrawal. No
                  lasting effects.
                </p>
              </div>

              {/* Testimonials Section */}
              <div className="mb-10" data-id="element-258">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-259">
                  Real Parents, Real Results
                </h2>

                {/* Real Parents Real Results Image */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-260">
                  <img src="https://cdn.magicpatterns.com/uploads/bATS3T1j4KYUxCg5BFaJMk/ChatGPT_Image_11_Ιαν_2026,_12_40_22_μ.μ..png" alt="Three happy, focused children engaged in different activities - doing homework, playing outside, and reading - showing the positive transformation after using Nymera" className="w-full h-auto" data-id="element-261" />
                </div>

                <div className="space-y-6 mb-6" data-id="element-262">
                  <TestimonialCard quote="We eliminated gluten. We tried occupational therapy. We spent thousands on supplements. Nothing worked. Then a mom in my Facebook group mentioned methylfolate. Within a month, his teachers asked what changed. He's focusing better. He's calmer. Homework doesn't end in tears anymore. I wish someone had told me about this three years ago." author="Sarah" location="Ohio" imageUrl="https://i.pravatar.cc/150?img=47" data-id="element-263" />

                  <TestimonialCard quote="My daughter is 7. She's always been anxious. She struggled in school. Her pediatrician wanted to put her on medication. I said no. I wanted to try other things first. We started giving her liquid drops with methylfolate. Just a few drops in her morning juice. Every teacher and therapist has commented on the difference this school year. She's finally thriving." author="Jessica" location="California" imageUrl="https://i.pravatar.cc/150?img=32" data-id="element-264" />

                  <TestimonialCard quote="He wasn't talking much. We were in speech therapy twice a week. Making slow progress. Someone in our therapy group mentioned methylfolate for kids with the MTHFR gene. Within a few weeks, he started using more words. He's more present. More engaged. When we run out and forget to reorder, we really notice the difference." author="Michael" location="Texas" imageUrl="https://i.pravatar.cc/150?img=12" data-id="element-265" />
                </div>
              </div>

              {/* Here's What Happens If You Wait Section */}
              <div className="mb-10" data-id="element-266">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-267">
                  Here's What Happens If You Wait
                </h2>

                <p className="mb-4 text-base leading-relaxed" data-id="element-268">
                  I know you're careful about trying new things. That's good.
                  You're a thoughtful parent.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-269">
                  But here's what you need to know.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-270">
                  Every day your child's brain runs on empty is another day of
                  struggle.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-271">
                  Another morning battle. Another teacher email. Another
                  meltdown at dinner.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-272">
                  Another day watching your child try so hard and still fall
                  short.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-273">
                  These are critical years for brain development. For learning.
                  For social skills. For building confidence.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-274">
                  The longer the brain goes without the fuel it needs, the
                  further behind your child falls.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-275">
                  You have two choices.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-276">
                  Keep doing what you've been doing. Hope that eventually,
                  something clicks.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-277">
                  Or try something different.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-278">
                  What if this is the missing piece? What if 30 days from now,
                  mornings are calmer? Homework is easier? Your child is finally
                  thriving?
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-279">
                  What would that be worth?
                </p>
              </div>

              {/* Special Offer Section */}
              <div className="mb-10 bg-gray-100 p-4 sm:p-6 rounded-lg" data-id="element-280">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-281">
                  Special Offer for New Customers
                </h2>

                {/* IMAGE 6 - Product with packaging and guarantee */}
                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-282">
                  <img src="https://cdn.magicpatterns.com/uploads/6HJ514XY116KrrN2MsjViq/ChatGPT_Image_11_Ιαν_2026,_12_26_22_μ.μ..png" alt="Nymera Kids Focus Drops with packaging box, 30-Day Money Back Guarantee badge, and dropper dispensing into juice" className="w-full h-auto" data-id="element-283" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-284">
                  Right now, you can try Nymera Kids Focus Drops and save 25%.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-285">
                  No subscription required. No hidden fees. No tricks.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-286">
                  Just one bottle to see if it works for your child.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-287">
                  And here's the best part.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-288">
                  If you don't see improvement after 30 days, you get your money
                  back. No questions asked. No hassle.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-289">
                  You have nothing to lose.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-290">
                  Your child deserves a chance to thrive. To feel calm. To
                  focus. To be happy.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-291">
                  Give them that chance.
                </p>

                <div className="mt-6" data-id="element-292">
                  <CTAButton data-id="element-293" />
                </div>
              </div>

              {/* You Deserve Section */}
              <div className="mb-10" data-id="element-294">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-295">
                  You Deserve Relief That Works
                </h2>

                {/* IMAGE 7 - Happy child success */}
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-296">
                  <img src="https://cdn.magicpatterns.com/uploads/wRegpfCVAG5UuDUSnSmYx3/ChatGPT_Image_11_Ιαν_2026,_12_26_21_μ.μ..png" alt="Happy, focused child doing homework successfully with smiling parent in background, showing the transformation after using Nymera" className="w-full h-auto" data-id="element-297" />
                </div>

                <p className="mb-4 text-base leading-relaxed" data-id="element-298">
                  I want you to imagine something.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-299">
                  Imagine waking up tomorrow and seeing your child focused and
                  engaged at the breakfast table.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-300">
                  Imagine homework time without tears. Without battles. Your
                  child sitting down, concentrating, and actually finishing
                  their work.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-301">
                  Imagine getting an email from the teacher that says, "I wanted
                  to let you know how well [child's name] is doing. They're more
                  focused and participating more in class."
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-302">
                  Imagine bedtime without meltdowns. Mornings without fights.
                  Evenings where your family actually enjoys being together.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-303">
                  Imagine watching your child make a friend. Seeing them laugh
                  and play without struggle.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-304">
                  That's what Nymera has given thousands of parents. And that's
                  what it can give you.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-305">
                  You're not alone. You're not broken. You're not imagining
                  this.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-306">
                  Your child's struggles are real. And now there's finally
                  something that actually helps.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-307">
                  Don't spend another day watching your child struggle. Don't
                  waste another season feeling helpless. Don't let another year
                  go by feeling stuck.
                </p>

                <p className="mb-4 text-base leading-relaxed" data-id="element-308">
                  Your child deserves relief. And you deserve to see them
                  thrive.
                </p>

                <div className="mt-6" data-id="element-309">
                  <CTAButton data-id="element-310" />
                </div>
              </div>
            </div>
          </main>

          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-311">
            <div className="sticky top-6" data-id="element-312">
              <StickyCTA showNewImage={true} data-id="element-313" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-314">
        <a href="https://trynymera.com/products/nymera-kids-focus-drops" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block text-sm sm:text-base" data-id="element-315">
          GET 25% OFF NYMERA KIDS FOCUS DROPS NOW!
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-316">
        <div className="container mx-auto px-4 py-6" data-id="element-317">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-318">
            <div className="flex items-center" data-id="element-319">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-320" />
              <p className="font-bold text-base sm:text-lg" data-id="element-321">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-sm sm:text-base md:text-lg px-4" data-id="element-322">
              Get Nymera Kids Focus Drops at 25% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://trynymera.com/products/nymera-kids-focus-drops" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-sm sm:text-base whitespace-nowrap inline-block" data-id="element-323">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-324">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-325">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-326">
            <p className="mb-4 font-semibold" data-id="element-327">
              IMPORTANT NOTE: This statement has not been evaluated by the Food
              and Drug Administration. This product is not intended to diagnose,
              treat, cure, or prevent any disease. Results may vary. Always
              consult your pediatrician before starting any new supplement,
              especially if your child has existing medical conditions or takes
              medications.
            </p>
            <p className="mb-2" data-id="element-328">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-329">
              <span data-id="element-330">About Us</span>
              <span data-id="element-331">|</span>
              <span data-id="element-332">Terms of Use</span>
              <span data-id="element-333">|</span>
              <span data-id="element-334">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-335">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-336">©2025 Parent Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};